export const NOTIFICATION_OF_END_OF_TARIFF_IN_DAYS = 10
